import React from "react";
import Meaning from "./Meaning";
import "./Results.css"




export default function Results(props) {
  if (props.results) {
    return (
      <div className="Results">
        <section className="word">
          <h2>{props.results.word}</h2>
          <h3>{props.results.phonetic}</h3>
        </section>
<br/>
<section>
        {props.results.meanings.map(function (meaning, index) {
          return (
            <div key={index}>
              <Meaning meaning={meaning} />
            </div>
          );
        })}</section>
      </div>
    );
  } else {
    return null;
  }
}
